/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meow Mobile API
 * MeowStore 모바일 백엔드 API 명세
 * OpenAPI spec version: v1.0.0
 */

/**
 * 라운드 상태
 */
export type WorldcupRoundDtoStatus = (typeof WorldcupRoundDtoStatus)[keyof typeof WorldcupRoundDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorldcupRoundDtoStatus = {
  PENDING: 'PENDING',
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
} as const;
